import React from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Typography,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

interface IConfirmDelete {
  open: boolean;
  process?: boolean;
  onClose?: boolean;
  cancel: Function;
  accept: Function;
}

const useStyle = makeStyles((theme: Theme) => ({
  content: {
    width: theme.spacing(55),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  icon: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    color: theme.palette.error.main,
  },
  btn: { textTransform: "unset", fontWeight: "bold" },
}));

const ConfirmDelete = (props: IConfirmDelete) => {
  const { open, onClose, cancel, accept, process } = props;
  const classes = useStyle();
  const _onCancel = () => {
    cancel();
  };

  const _onDelete = () => {
    accept();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose ? _onCancel : () => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent className={classes.content}>
        <Delete className={classes.icon} />
        <Typography variant="h6">Are you sure ?</Typography>
        <DialogContentText>You won't be able to revert this!</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.btn}
          variant="contained"
          onClick={_onCancel}
          color="secondary"
          disabled={Boolean(process)}
        >
          Cancel
        </Button>
        <Button
          className={classes.btn}
          variant="contained"
          onClick={_onDelete}
          color="primary"
          autoFocus
          disabled={Boolean(process)}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDelete;
